export default [
  {
    path: 'HR_management',
    name: 'HR_management',
    component: () => import('../pages/HR/Management.vue'),
    meta: {
      requiresAuth: true,
      breadcrumb: [{ parent: 'monitor', label: 'HR_management' }],
    },
  },
  {
    path: 'students_by_degree',
    name: 'students_by_degree',
    component: () => import('../pages/Contingent/Student.vue'),
    meta: {
      requiresAuth: true,
      breadcrumb: [{ parent: 'monitor', label: 'center_monitoring' }],
    },
  },



  {
    path: 'HR_potential',
    name: 'HR_potential',
    component: () => import('../pages/CrudDemo.vue'),
    meta: {
      requiresAuth: true,
      breadcrumb: [{ parent: 'HR_management', label: 'HR_potential' }],
    },
  },
  {
    path: 'by_category',
    name: 'by_category',
    component: () => import('../pages/CrudDemo1.vue'),
    meta: {
      requiresAuth: true,
      breadcrumb: [{ parent: 'HR_management', label: 'by category' }],
    },
  },
  {
    path: 'crud_students_by_degree',
    name: 'crud_students_by_degree',
    component: () => import('../pages/CrudDemo2.vue'),
    meta: {
      requiresAuth: true,
      breadcrumb: [{ parent: 'HR_management', label: 'students_by_degree' }],
    },
  },
  {
    path: 'crud_students_by_degree1',
    name: 'crud_students_by_degree1',
    component: () => import('../pages/Contingent/StudentNew.vue'),
    meta: {
      requiresAuth: true,
      breadcrumb: [{ parent: 'HR_management', label: 'students_by_degree' }],
    },
  },
]
